import { useRemoteData } from './useRemoteData';

export type AvailabilityResponseRecord = {
  date: string;
  max_deliveries: number;
  deviation_in_weeks: number;
};

const buildEndpointUrl = (
  id: string,
  productId: string | undefined,
  terms: string[]
) =>
  `portal/api/bff/deals/${id}/product-swap-availabilities?product_id=${productId}&terms=${terms.join(',')}`;

export const useProductSwapAvailabilities = (
  id: string | null,
  productId: string | undefined,
  terms: string[]
) => {
  const shouldFetch =
    Boolean(id) && Boolean(productId) && Boolean(terms.length);

  const endpointKey = shouldFetch
    ? `product-swap-availabilities/${id}/${productId}/${terms.join(',')}`
    : null;

  const fetchFn = () => buildEndpointUrl(id!, productId, terms);

  return useRemoteData<AvailabilityResponseRecord[]>(endpointKey, fetchFn);
};
